import LoginForm from './login_form';

export default LoginForm;
